export default __webpack_public_path__ + "static/media/error-icon.1ffb2891.svg";